import { Switch } from 'antd';
import clsx from 'clsx';
import Button from 'components/Button';
import Text from 'components/Text';
import React from 'react';
import styled from 'styled-components';

type SwitchBtnProps = {
  label?: string;
  onChange?: (val: boolean) => void;
  value?: boolean;
  style?: React.CSSProperties;
  labelClassName?: string;
};

const SwitchBtn = ({ style, label = '', labelClassName, onChange = () => undefined, value = false }: SwitchBtnProps) => (
  <Styled style={style} size='small' ntype='GHOST' className="btn-switch" onClick={() => onChange(!value)}>
    <Switch checked={value} onChange={onChange} />
    {label && <Text className={clsx('label', labelClassName)}>{label}</Text>}
  </Styled>

);
export default SwitchBtn;

const Styled = styled(Button)`
&.btn-switch {
&.ant-btn.ant-btn-sm {
  padding: 0;
}
  .ant-switch {
    zoom: 1.3;
    &.ant-switch.ant-switch-checked {
      background: #6FABB6;
    }
    .ant-switch-handle {
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .CONTENT_2 {
    display: flex;
    align-items: center;
    gap: 12px;
    .label {
      color: #1D2129;
      text-align: right;
      font-family: "Open Sans";
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;

      &.section-label {
        color: #1D2129;
        font-family: Poppins;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: normal; 
      }
    }
  }
}
`;